// ノートテンプレートのグループ選択肢まわりの判定
// 仕様: docs/superpowers/specs/2026-09-14-note-template-department-options-design.html

// グループオブジェクトの配列から id だけを取り出す
export const toDepartmentIds = (departments) => {
  return (departments || []).map(department => department.id)
}

// 編集・削除できるテンプレートか（定義書 R3）
// 「すべてのグループ」は常に可。個別グループは閲覧可能グループを1つ以上含めば可
export const isEditableNoteTemplate = (noteTemplate, accessibleDepartmentIds) => {
  if (!noteTemplate) return false
  if (noteTemplate.isAllDepartments) return true
  const ids = accessibleDepartmentIds || []
  return (noteTemplate.departments || []).some(department => ids.includes(department.id))
}

// 編集画面でグループ欄をロックするか（定義書 R4）
// 閲覧権限のないグループが混ざっていると、選択肢に出せないグループを
// フォームから復元できずに取りこぼすため、付け替え自体をさせない
export const isDepartmentLocked = (noteTemplate, accessibleDepartmentIds) => {
  if (!noteTemplate || noteTemplate.isAllDepartments) return false
  const ids = accessibleDepartmentIds || []
  return (noteTemplate.departments || []).some(department => !ids.includes(department.id))
}

// ロック時のチェックボックスに並べる選択肢（定義書 R4a）
// 何が設定されているか読めるよう、権限外グループも末尾に足して表示する
export const buildLockedDepartmentOptions = (accessibleDepartments, noteTemplate) => {
  const options = [...accessibleDepartments || []]
  const seenIds = options.map(department => department.id)
  const departments = noteTemplate && noteTemplate.departments || []
  departments.forEach(department => {
    if (seenIds.includes(department.id)) return
    options.push(department)
    seenIds.push(department.id)
  })
  return options
}
